export const GOT_TRANSLATIONS = 'got-translations';
const gotTranslations = ({ translations }) => ({
  type: GOT_TRANSLATIONS,
  payload: { translations },
});
export default gotTranslations;
